import styled from "styled-components";
import { FlexStyledInterface } from "../../entities/Flex";

export const FlexStyled = styled.div<FlexStyledInterface>`
  display: flex;
  flex-direction: ${(props: FlexStyledInterface) => props.direction || "row"};
  align-items: ${(props: FlexStyledInterface) => props.align || "center"};
  justify-content: ${(props: FlexStyledInterface) =>
    props.justify || "stretch"};
  flex-wrap: ${(props: FlexStyledInterface) => props.wrap || "nowrap"};
  height: 100%;
`;
